import React, { useState } from "react";

import LazyShow from "./LazyShow";
import Hero from "./Hero";
import About from "./About";
import LatestNews from "./LatestNews";
import Network from "./Network";
import Organization from "./Organization";
import Header from "./Header";
import Footer from "./Footer";
function Home() {
  return (
    <div>
      <LazyShow>
        <>
          <Header />
        </>
      </LazyShow>
      <LazyShow>
        <>
          <Hero />
        </>
      </LazyShow>
      <LazyShow>
        <>
          <About />
        </>
      </LazyShow>
      <LazyShow>
        <>
          <LatestNews />
        </>
      </LazyShow>
      <LazyShow>
        <>
          <Network />
        </>
      </LazyShow>
      <LazyShow>
        <>
          <Organization />
        </>
      </LazyShow>
      <LazyShow>
        <>
          <Footer />
        </>
      </LazyShow>
    </div>
  );
}

export default Home;
